<h2 class="popup-heading" mat-dialog-title>Add New Notification</h2>
<form>
  <mat-dialog-content class="mat-typography">
    <div class="row">
      <div class="col-md-12">
        <mat-form-field appearance="fill">
          <mat-label>Title</mat-label>
          <input matInput placeholder="Enter Title" [formControl]="form.controls.title"
            required>
          @if (form.controls.title.hasError('required')) {
            <mat-error>
              Title is <strong>required</strong>
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Notfication Message</mat-label>
          <input matInput placeholder="Enter Notifcation Message" [formControl]="form.controls.message"
            required>
          @if (form.controls.message.hasError('required')) {
            <mat-error>
              Notifcation Message is <strong>required</strong>
            </mat-error>
          }
        </mat-form-field>
        <!-- <mat-form-field appearance="fill">
        <mat-label>Platform</mat-label>
        <mat-select  [formControl]="form.controls.app">
          <mat-option value="0">IOS</mat-option>
          <mat-option value="1">Android</mat-option>
          <mat-option value="2">Both</mat-option>
        </mat-select>
      </mat-form-field> -->
      <div class="extra-field ignite-editor">
        <quill-editor [formControl]="form.controls.content" [modules]="editorModules" [placeholder]="editorPlaceholder"></quill-editor>

      </div>
      <mat-form-field appearance="fill" class="single-field">
        <mat-label>App Version</mat-label>
        <input matInput [formControl]="form.controls.version">
      </mat-form-field>
    </div>
  </div>
  <div>
    <mat-checkbox class="add-smpte-chkbx" [formControl]="form.controls.upgrade_message"> Upgrade Message
    </mat-checkbox>
  </div>
  <div>
    <mat-checkbox class="add-smpte-chkbx" [formControl]="form.controls.critical"> Critical
    </mat-checkbox>
  </div>
  <div>
    <mat-checkbox class="add-smpte-chkbx" [formControl]="form.controls.testonly"> Test Only
    </mat-checkbox>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button class="cancel-popup" mat-button mat-dialog-close>Cancel</button>
  <button class="popup-save" mat-button type="submit" (click)="save()" [disabled]="processing">
    @if (processing) {
      <mat-icon>
        <mat-spinner  diameter="20"></mat-spinner>
      </mat-icon>
    }
    Save
  </button>
</mat-dialog-actions>
</form>
